<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chart"
  style="height: 280px; width: 100%; display: block"></highcharts-chart>
